// 问卷调查
<template>
  <el-card>
    <el-form inline ref="searchInfo" :model="info">
      <el-form-item prop="questionnaireTitle">
        <el-input v-model="info.questionnaireTitle" placeholder="请输入问卷名称" clearable></el-input>
      </el-form-item>
      <el-form-item prop="projectId">
        <el-select v-model="info.projectId" placeholder="请选择公园名称" clearable filterable>
          <el-option v-for="(item, index) in projectList" :key="index" :label="item.projectName"
            :value="item.projectId"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="isPublished">
        <el-select v-model="info.isPublished" clearable placeholder="问卷状态">
          <el-option label="已下架" value="0"></el-option>
          <el-option label="已上架" value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSearch">查询</el-button>
      </el-form-item>
    </el-form>
    <el-button class="mb20" @click='onAdd' type="primary" icon='el-icon-plus'
      v-if="$ButtonShow('QUE_ADD_01')">添加自定义调查</el-button>

    <el-tabs type="card" v-model="info.questionnaireType" @tab-click="onSearch">
      <el-tab-pane label="满意率调查" name="2"></el-tab-pane>
      <el-tab-pane label="自定义调查" name="1"></el-tab-pane>
    </el-tabs>
    <el-table class="global-table" v-loading="loading" :data="tableData">
      <el-table-column label="问卷标题" show-overflow-tooltip prop="questionnaireTitle"></el-table-column>
      <el-table-column label="答卷数量" show-overflow-tooltip prop="numberOfAnswers"></el-table-column>
      <el-table-column label="二维码" show-overflow-tooltip prop="miniProgramQRCodeUrl">
        <template v-slot="{ row }">
          <el-image v-if="row.miniProgramQRCodeUrl" :src="row.miniProgramQRCodeUrl"
            :preview-src-list="[row.miniProgramQRCodeUrl]" fit="fill"></el-image>
        </template>
      </el-table-column>
      <el-table-column label="所属公园" show-overflow-tooltip prop="projectName"></el-table-column>
      <el-table-column label="问卷状态" show-overflow-tooltip prop="isPublished">
        <template v-slot="{ row }">
          {{ row.isPublished === '1' ? '已上架' : '已下架' }}
        </template>
      </el-table-column>
      <el-table-column v-if="info.questionnaireType === '1'" label="创建时间" show-overflow-tooltip
        prop="createTime"></el-table-column>
      <el-table-column label="操作" width="180px" fixed="right">
        <template v-slot="{ row }">
          <el-button type="text" @click="onPub(row.id, row.isPublished)" v-if="$ButtonShow('QUE_EDT_02')">{{
            row.isPublished === '0' ?
              '上架' : '下架' }}</el-button>
          <el-button type="text" @click="onDetail(row)">查看调查结果</el-button>
          <template v-if="info.questionnaireType === '1'">
            <el-button type="text"
              v-if="row.isPublished === '0' && row.numberOfAnswers === 0 && $ButtonShow('QUE_EDT_01')"
              @click="onUpdate(row.id)">编辑</el-button>
            <el-button type="text" @click="onDelete(row.id)" v-if="$ButtonShow('QUE_DEL_01')">删除</el-button>
          </template>
        </template>
      </el-table-column>
    </el-table>
    <GlobalPagination @size-change="loadData" @current-change="loadData" :current-page.sync="page"
      :page-size.sync="size" :total="total">
    </GlobalPagination>
  </el-card>
</template>

<script>
import keepAlive from '@/mixins/keepAlive.js'
export default {
  name: 'Questionsurvey',
  mixins: [keepAlive],
  data() {
    return {
      info: {
        projectName: '',
        questionnaireTitle: '',
        questionnaireType: '2',
        isPublished: ''
      },
      loading: false,
      page: 1,
      size: 10,
      total: 0,
      tableData: [],
      isShowRadio: false,
      isShowMult: false,
      fillId: '',
      projectList: []
    }
  },
  created() {
    this.loadData()
    this.getPark()
  },
  methods: {
    // 获取公园列表
    getPark() {
      this.$axios.get(this.$apis.project.selectYhProjectByPage, {
        projectType: '4',
        page: 1,
        size: 100,
        isCad: 0
      }).then(res => {
        this.projectList = res.list || []
      })
    },
    loadData() {
      this.loading = true
      this.$axios.get(this.$apis.tourist.selectQuestionnaireByPage, {
        ...this.info,
        page: this.page,
        size: this.size
      }).then(res => {
        this.total = res.total || 0
        this.tableData = res.list || []
      }).finally(() => {
        this.loading = false
      })
    },
    onSearch() {
      this.page = 1
      this.loadData()
    },
    onAdd() {
      this.$router.push('/questionsurvey/add')
    },
    onUpdate(id) {
      this.$router.push({
        name: 'QuestionsurveyUpdate',
        params: { id }
      })
    },
    onPub(id, isPublished) {
      this.$axios.post(this.$apis.tourist.publishQuestionnaireById, {
        id: id
      }).then(() => {
        this.loadData()
        this.$message({
          message: isPublished === '0' ? '上架成功' : '下架成功',
          type: 'success'
        })
      })
    },
    onDetail(row) {
      if (this.info.questionnaireType === '2') {
        // this.$router.push({
        //   name: 'QuestionsurveyDetail2',
        //   params: { id: row.id }
        // })
        this.$router.push(`/questionsurvey/details/${row.id}?projectName=` + row.projectName + '&projectId=' + row.projectId)
      } else {
        this.$router.push({
          name: 'QuestionsurveyDetail',
          params: { id: row.id }
        })
      }
    },
    onDelete(id) {
      this.$confirm('确认删除吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.tourist.deleteQuestionnaire, {
          id: id
        }).then(() => {
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.loadData()
        })
      })
    }
  }
}
</script>

<style scoped lang="scss">
.el-image {
  width: 70px;
  height: 70px;
}
</style>
